import React from 'react'

function ConditionalHtml(props) {
  const { conditionForCastFilter, handleSelectCondition } = props
  return (
    // <div>
    //   <lable>select condition OR/AND</lable>
    //   <button onClick={handleCondition} className='ml-1 text-red btn btn-primary'>
    //     {` ${conditionForCastFilter} `}
    //   </button>
    //   {showConditionUi ? (
    //     <div className='d-flex gap-2 m-1'>
    //       <button className=' w-2 btn btn-primary' onClick={() => handleSelectCondition('or')}>
    //         Or
    //       </button>
    //       <button className=' w-2 btn btn-primary' onClick={() => handleSelectCondition('and')}>
    //         And
    //       </button>
    //     </div>
    //   ) : (
    //     ''
    //   )}
    // </div>
    <div className='d-flex gap-1'>
      <label>select condition OR/AND</label>
      <select
        defaultValue={'OR'}
        value={conditionForCastFilter}
        onChange={e => handleSelectCondition(e)}
        required
      >
        <option value='' disabled selected>
          select condition
        </option>
        <option value='OR' selected={conditionForCastFilter === 'OR'}>
          OR
        </option>
        <option value='AND' selected={conditionForCastFilter === 'AND'}>
          AND
        </option>
      </select>
    </div>
  )
}

export default ConditionalHtml
